export default {
    methods: {
        dataLayerAdd(event, path) {
            if (path && (path.split('/').pop() !== 'undefined-undefined')) {
                window.dataLayer.push({
                    ...event.type && { event: event.type },
                    ...event.category && { eventCategory: event.category },
                    ...event.action && { eventAction: event.action },
                    ...event.label && { eventLabel: event.label },
                    ...path && { virtualPagePath: path }
                })
            } else {
                window.dataLayer.push({
                    ...event.type && { event: event.type },
                    ...event.category && { eventCategory: event.category },
                    ...event.action && { eventAction: event.action },
                    ...event.label && { eventLabel: event.label }
                })
            }
        }
    }
}
